import icon_alert from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/alert.svg?raw'
import icon_area from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/area.svg?raw'
import icon_arrow_down from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/arrow-down.svg?raw'
import icon_arrow_left from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/arrow-left.svg?raw'
import icon_arrow_right from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/arrow-right.svg?raw'
import icon_arrow_right_thin from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/arrow-right-thin.svg?raw'
import icon_arrow_up from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/arrow-up.svg?raw'
import icon_artboard from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/artboard.svg?raw'
import icon_artboard_disabled from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/artboard-disabled.svg?raw'
import icon_artboard_enabled from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/artboard-enabled.svg?raw'
import icon_bug from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/bug.svg?raw'
import icon_button_pointer from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/button-pointer.svg?raw'
import icon_caret from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/caret.svg?raw'
import icon_cellphone from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/cellphone.svg?raw'
import icon_chat_question from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/chat-question.svg?raw'
import icon_check from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/check.svg?raw'
import icon_checkbox from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/checkbox.svg?raw'
import icon_checks from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/checks.svg?raw'
import icon_chevron_left from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/chevron-left.svg?raw'
import icon_chevron_right from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/chevron-right.svg?raw'
import icon_clipboard from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/clipboard.svg?raw'
import icon_close from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/close.svg?raw'
import icon_cog from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/cog.svg?raw'
import icon_command from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/command.svg?raw'
import icon_comment from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/comment.svg?raw'
import icon_comment_add from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/comment_add.svg?raw'
import icon_convert from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/convert.svg?raw'
import icon_cursor_move from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/cursor-move.svg?raw'
import icon_dead from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/dead.svg?raw'
import icon_delete from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/delete.svg?raw'
import icon_detach from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/detach.svg?raw'
import icon_diff from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/diff.svg?raw'
import icon_drag from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/drag.svg?raw'
import icon_duplicate from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/duplicate.svg?raw'
import icon_edit from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/edit.svg?raw'
import icon_exit from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/exit.svg?raw'
import icon_expand from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/expand.svg?raw'
import icon_eye from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/eye.svg?raw'
import icon_file from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/file.svg?raw'
import icon_form from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/form.svg?raw'
import icon_fragment from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/fragment.svg?raw'
import icon_grid from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/grid.svg?raw'
import icon_group from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/group.svg?raw'
import icon_help from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/help.svg?raw'
import icon_history from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/history.svg?raw'
import icon_icon_blokkli_option_box_bottom from '/var/www/html/frontend/app/components/Paragraph/CallToActionSection/icon-blokkli-option-box-bottom.svg?raw'
import icon_icon_blokkli_option_box_top from '/var/www/html/frontend/app/components/Paragraph/CallToActionSection/icon-blokkli-option-box-top.svg?raw'
import icon_icon_blokkli_option_chart_bar from '/var/www/html/frontend/app/components/Paragraph/Chart/icon-blokkli-option-chart-bar.svg?raw'
import icon_icon_blokkli_option_chart_bar_horizontal from '/var/www/html/frontend/app/components/Paragraph/Chart/icon-blokkli-option-chart-bar-horizontal.svg?raw'
import icon_icon_blokkli_option_chart_line from '/var/www/html/frontend/app/components/Paragraph/Chart/icon-blokkli-option-chart-line.svg?raw'
import icon_icon_blokkli_option_grid from '/var/www/html/frontend/app/components/Paragraph/TeaserList/icon-blokkli-option-grid.svg?raw'
import icon_icon_blokkli_option_image_left from '/var/www/html/frontend/app/components/Paragraph/CallToActionSection/icon-blokkli-option-image-left.svg?raw'
import icon_icon_blokkli_option_image_right from '/var/www/html/frontend/app/components/Paragraph/CallToActionSection/icon-blokkli-option-image-right.svg?raw'
import icon_icon_blokkli_option_large from '/var/www/html/frontend/app/components/Paragraph/Milestones/icon-blokkli-option-large.svg?raw'
import icon_icon_blokkli_option_large_spacing from '/var/www/html/frontend/app/components/Paragraph/Text/icon-blokkli-option-large-spacing.svg?raw'
import icon_icon_blokkli_option_left from '/var/www/html/frontend/app/components/Paragraph/Quote/icon-blokkli-option-left.svg?raw'
import icon_icon_blokkli_option_medium from '/var/www/html/frontend/app/components/Paragraph/Milestones/icon-blokkli-option-medium.svg?raw'
import icon_icon_blokkli_option_no_spacing from '/var/www/html/frontend/app/components/Paragraph/Text/icon-blokkli-option-no-spacing.svg?raw'
import icon_icon_blokkli_option_original from '/var/www/html/frontend/app/components/Paragraph/Image/icon-blokkli-option-original.svg?raw'
import icon_icon_blokkli_option_right from '/var/www/html/frontend/app/components/Paragraph/Quote/icon-blokkli-option-right.svg?raw'
import icon_icon_blokkli_option_slider from '/var/www/html/frontend/app/components/Paragraph/TeaserList/icon-blokkli-option-slider.svg?raw'
import icon_icon_blokkli_option_slider_desktop from '/var/www/html/frontend/app/components/Paragraph/TeaserList/icon-blokkli-option-slider-desktop.svg?raw'
import icon_icon_blokkli_option_small from '/var/www/html/frontend/app/components/Paragraph/Image/icon-blokkli-option-small.svg?raw'
import icon_icon_blokkli_option_small_spacing from '/var/www/html/frontend/app/components/Paragraph/Text/icon-blokkli-option-small-spacing.svg?raw'
import icon_icon_blokkli_option_staggered from '/var/www/html/frontend/app/components/Paragraph/TeaserList/icon-blokkli-option-staggered.svg?raw'
import icon_icon_blokkli_option_stapel from '/var/www/html/frontend/app/components/Paragraph/TeaserList/icon-blokkli-option-stapel.svg?raw'
import icon_icon_blokkli_option_table_horizontal from '/var/www/html/frontend/app/components/Paragraph/Table/icon-blokkli-option-table-horizontal.svg?raw'
import icon_icon_blokkli_option_table_vertical from '/var/www/html/frontend/app/components/Paragraph/Table/icon-blokkli-option-table-vertical.svg?raw'
import icon_icon_blokkli_option_xlarge from '/var/www/html/frontend/app/components/Paragraph/Image/icon-blokkli-option-xlarge.svg?raw'
import icon_image from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/image.svg?raw'
import icon_import from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/import.svg?raw'
import icon_info from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/info.svg?raw'
import icon_laptop from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/laptop.svg?raw'
import icon_list_view_grid from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/list-view-grid.svg?raw'
import icon_list_view_horizontal from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/list-view-horizontal.svg?raw'
import icon_loader from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/loader.svg?raw'
import icon_logo from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/logo.svg?raw'
import icon_magnifier from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/magnifier.svg?raw'
import icon_menu from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/menu.svg?raw'
import icon_minus from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/minus.svg?raw'
import icon_monitor from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/monitor.svg?raw'
import icon_multi_select from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/multi-select.svg?raw'
import icon_multimedia from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/multimedia.svg?raw'
import icon_opacity from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/opacity.svg?raw'
import icon_open_in_new from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/open_in_new.svg?raw'
import icon_palette from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/palette.svg?raw'
import icon_plus from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/plus.svg?raw'
import icon_plus_box from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/plus-box.svg?raw'
import icon_preview from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/preview.svg?raw'
import icon_publish from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/publish.svg?raw'
import icon_puzzle from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/puzzle.svg?raw'
import icon_qrcode from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/qrcode.svg?raw'
import icon_question from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/question.svg?raw'
import icon_redo from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/redo.svg?raw'
import icon_resize from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/resize.svg?raw'
import icon_reusable from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/reusable.svg?raw'
import icon_revert from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/revert.svg?raw'
import icon_robot from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/robot.svg?raw'
import icon_rotate_phone from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/rotate-phone.svg?raw'
import icon_sad from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/sad.svg?raw'
import icon_save from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/save.svg?raw'
import icon_script from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/script.svg?raw'
import icon_scrolltotop from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/scrolltotop.svg?raw'
import icon_search from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/search.svg?raw'
import icon_selection from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/selection.svg?raw'
import icon_spinner from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/spinner.svg?raw'
import icon_star from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/star.svg?raw'
import icon_swap_horizontal from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/swap-horizontal.svg?raw'
import icon_tablet from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/tablet.svg?raw'
import icon_textbox from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/textbox.svg?raw'
import icon_texturebox from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/texturebox.svg?raw'
import icon_tiktok from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/tiktok.svg?raw'
import icon_title from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/title.svg?raw'
import icon_tools from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/tools.svg?raw'
import icon_translate from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/translate.svg?raw'
import icon_tree from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/tree.svg?raw'
import icon_tutor from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/tutor.svg?raw'
import icon_ui_list_horizontal from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/ui-list-horizontal.svg?raw'
import icon_ui_list_sidebar from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/ui-list-sidebar.svg?raw'
import icon_ui_list_vertical from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/ui-list-vertical.svg?raw'
import icon_undo from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/undo.svg?raw'
import icon_unstar from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/unstar.svg?raw'
import icon_upload from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/upload.svg?raw'
import icon_user from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/user.svg?raw'
import icon_video_outline from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/video-outline.svg?raw'
import icon_vimeo from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/vimeo.svg?raw'
import icon_window_maximize from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/window-maximize.svg?raw'
import icon_window_minimize from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/window-minimize.svg?raw'
import icon_youtube from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/icons/youtube.svg?raw'


export const icons = {
  'alert': icon_alert,
  'area': icon_area,
  'arrow-down': icon_arrow_down,
  'arrow-left': icon_arrow_left,
  'arrow-right': icon_arrow_right,
  'arrow-right-thin': icon_arrow_right_thin,
  'arrow-up': icon_arrow_up,
  'artboard': icon_artboard,
  'artboard-disabled': icon_artboard_disabled,
  'artboard-enabled': icon_artboard_enabled,
  'bug': icon_bug,
  'button-pointer': icon_button_pointer,
  'caret': icon_caret,
  'cellphone': icon_cellphone,
  'chat-question': icon_chat_question,
  'check': icon_check,
  'checkbox': icon_checkbox,
  'checks': icon_checks,
  'chevron-left': icon_chevron_left,
  'chevron-right': icon_chevron_right,
  'clipboard': icon_clipboard,
  'close': icon_close,
  'cog': icon_cog,
  'command': icon_command,
  'comment': icon_comment,
  'comment_add': icon_comment_add,
  'convert': icon_convert,
  'cursor-move': icon_cursor_move,
  'dead': icon_dead,
  'delete': icon_delete,
  'detach': icon_detach,
  'diff': icon_diff,
  'drag': icon_drag,
  'duplicate': icon_duplicate,
  'edit': icon_edit,
  'exit': icon_exit,
  'expand': icon_expand,
  'eye': icon_eye,
  'file': icon_file,
  'form': icon_form,
  'fragment': icon_fragment,
  'grid': icon_grid,
  'group': icon_group,
  'help': icon_help,
  'history': icon_history,
  'icon-blokkli-option-box-bottom': icon_icon_blokkli_option_box_bottom,
  'icon-blokkli-option-box-top': icon_icon_blokkli_option_box_top,
  'icon-blokkli-option-chart-bar': icon_icon_blokkli_option_chart_bar,
  'icon-blokkli-option-chart-bar-horizontal': icon_icon_blokkli_option_chart_bar_horizontal,
  'icon-blokkli-option-chart-line': icon_icon_blokkli_option_chart_line,
  'icon-blokkli-option-grid': icon_icon_blokkli_option_grid,
  'icon-blokkli-option-image-left': icon_icon_blokkli_option_image_left,
  'icon-blokkli-option-image-right': icon_icon_blokkli_option_image_right,
  'icon-blokkli-option-large': icon_icon_blokkli_option_large,
  'icon-blokkli-option-large-spacing': icon_icon_blokkli_option_large_spacing,
  'icon-blokkli-option-left': icon_icon_blokkli_option_left,
  'icon-blokkli-option-medium': icon_icon_blokkli_option_medium,
  'icon-blokkli-option-no-spacing': icon_icon_blokkli_option_no_spacing,
  'icon-blokkli-option-original': icon_icon_blokkli_option_original,
  'icon-blokkli-option-right': icon_icon_blokkli_option_right,
  'icon-blokkli-option-slider': icon_icon_blokkli_option_slider,
  'icon-blokkli-option-slider-desktop': icon_icon_blokkli_option_slider_desktop,
  'icon-blokkli-option-small': icon_icon_blokkli_option_small,
  'icon-blokkli-option-small-spacing': icon_icon_blokkli_option_small_spacing,
  'icon-blokkli-option-staggered': icon_icon_blokkli_option_staggered,
  'icon-blokkli-option-stapel': icon_icon_blokkli_option_stapel,
  'icon-blokkli-option-table-horizontal': icon_icon_blokkli_option_table_horizontal,
  'icon-blokkli-option-table-vertical': icon_icon_blokkli_option_table_vertical,
  'icon-blokkli-option-xlarge': icon_icon_blokkli_option_xlarge,
  'image': icon_image,
  'import': icon_import,
  'info': icon_info,
  'laptop': icon_laptop,
  'list-view-grid': icon_list_view_grid,
  'list-view-horizontal': icon_list_view_horizontal,
  'loader': icon_loader,
  'logo': icon_logo,
  'magnifier': icon_magnifier,
  'menu': icon_menu,
  'minus': icon_minus,
  'monitor': icon_monitor,
  'multi-select': icon_multi_select,
  'multimedia': icon_multimedia,
  'opacity': icon_opacity,
  'open_in_new': icon_open_in_new,
  'palette': icon_palette,
  'plus': icon_plus,
  'plus-box': icon_plus_box,
  'preview': icon_preview,
  'publish': icon_publish,
  'puzzle': icon_puzzle,
  'qrcode': icon_qrcode,
  'question': icon_question,
  'redo': icon_redo,
  'resize': icon_resize,
  'reusable': icon_reusable,
  'revert': icon_revert,
  'robot': icon_robot,
  'rotate-phone': icon_rotate_phone,
  'sad': icon_sad,
  'save': icon_save,
  'script': icon_script,
  'scrolltotop': icon_scrolltotop,
  'search': icon_search,
  'selection': icon_selection,
  'spinner': icon_spinner,
  'star': icon_star,
  'swap-horizontal': icon_swap_horizontal,
  'tablet': icon_tablet,
  'textbox': icon_textbox,
  'texturebox': icon_texturebox,
  'tiktok': icon_tiktok,
  'title': icon_title,
  'tools': icon_tools,
  'translate': icon_translate,
  'tree': icon_tree,
  'tutor': icon_tutor,
  'ui-list-horizontal': icon_ui_list_horizontal,
  'ui-list-sidebar': icon_ui_list_sidebar,
  'ui-list-vertical': icon_ui_list_vertical,
  'undo': icon_undo,
  'unstar': icon_unstar,
  'upload': icon_upload,
  'user': icon_user,
  'video-outline': icon_video_outline,
  'vimeo': icon_vimeo,
  'window-maximize': icon_window_maximize,
  'window-minimize': icon_window_minimize,
  'youtube': icon_youtube
}